// src/components/PropertyReport/utils/uploadUtils.js
const apiUrl = process.env.REACT_APP_API_URL;

const safeName = (name) =>
  (name || 'reporte').toString().trim()
    .replace(/[^\p{L}\p{N}\-_. ]/gu, '')
    .replace(/\s+/g, '_')
    .slice(0, 120);

const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token'); // <-- unificamos
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function uploadReportFile(blob, reportName, sessionId, fileType) {
  const base = safeName(reportName);
  const ext = fileType === 'pdf' ? 'pdf' : 'xlsx';
  const mime = fileType === 'pdf'
    ? 'application/pdf'
    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  const form = new FormData();
  form.append('session_id', String(sessionId));
  form.append('file_type', fileType); // 'pdf' | 'excel'
  form.append('report_name', base);
  form.append('file', new File([blob], `${base}.${ext}`, { type: mime }));

  const res = await fetch(`${apiUrl}/reports/upload-file`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: form,
    // credentials: 'include', // opcional; si tu backend usa SOLO Bearer podés omitirlo
  });

  if (!res.ok) {
    const t = await res.text().catch(() => '');
    throw new Error(`Upload error: ${res.status} ${t}`);
  }
  return res.json(); // { id, url, expires_at, ... }
}

export async function completeSession(sessionId) {
  const res = await fetch(`${apiUrl}/reports/sessions/${sessionId}/complete`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) {
    const t = await res.text().catch(() => '');
    throw new Error(`Complete error: ${res.status} ${t}`);
  }
  return res.json();
}
